



export const CategoriesSku = [
  {
    "category": "Accessories",
    "sku": ["EGVGBHDS001", "EGCGBPLD001", "EGCGBLM001"],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Fashion",
    "sku": [
      "EGCGBSP002",
      "EGCGBMIK001",
      "EGCGBARE001",
      "EGCGBBBLX001",
      "EGCGBRBLG001",
      "EGCGBDUNE001",
      "EGCGBSSLX001",
      "EGCGBGASLX001",
      "EGCGBMC001",
      "EGCGBHUB001",
      "EGCGBRBLC001",
      "EGCGBJC001",
      "EGCGBKSP001",
      "EGCGBSPLX001",
      "EGCGBLUXSD001",
      "EGCGBLUXSM001",
      "EGCGBLUXT001",
      "EGCGBBC001",
      "EGCGBTCNS002",
      "EGCGBTCNS001",
      "EGCGBFN001",
      "EGVGBVMARTUN001",
      "EGCGBFOS001",
      "EGCGBBSSH001",
      "EGVGBLNCL001",
      "EGCGBJKJN001",
      "EGCGBBSON001",
      "EGCGBBSVM001",
      "EGCGBITFL001",
      "EGCGBVM001",
      "EGCGBRS001",
      "EGCGBLPE001",
      "EGCGBANDI001",
      "EGCGBGDI001",
      "EGCGBBLBY001",
      "EGCGBNMPL002",
      "EGCGBWSS001",
      "EGCGBPAN001",
      "EGCGBPFS001",
      "EGCGBMYG001",
      "EGCGBTCQP015",
      "EGCGBTCQ002",
      "EGCGBMEA001",
      "EGCGBAJIORRL001",
      "EGCGBMYTS009",
      "EGCGBNYKA003",
      "EGCGBNYKA007",
      "EGCGBNYKA006",
      "EGCGBCTR001",
      "EGCGBRB001",
      "EGCGBREL011",
      "EGCGBREL005",
      "EGCGBREL012",
      "EGCGBREL006",
      "EGCGBREL010",
      "EGCGBCBK001",
      "EGCGBLVSS001",
      "EGCGBAWS001",
      "EGCGBPAS001",
      "EGCGBTNRS001",
      "EGCGBAPS001",
      "EGCGBFMS001",
      "EGCGBASS001",
      "EGVGBPES001",
      "EGCGBVHS001",
      "EGCGBCLTVP001"
    ],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Apple Accessories",
    "sku": ["EGCGBTSR001"],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Food & Beverages",
    "sku": [
      "EGCGBTCB001",
      "EGCGBCCD001",
      "EGCGBSUBW001",
      "EGCGBETSR018",
      "EGCGBETSR019",
      "EGCGBETSR020",
      "EGCGBETSR016",
      "EGCGBETSR017",
      "EGCGBETSR021",
      "EGCGBDEGCS001",
      "EGCGBLBF006",
      "EGCGBLBF005",
      "EGCGBAB001",
      "EGCGBLBF007",
      "EGCGBLBF001",
      "EGCGBLBF003",
      "EGCGBLBF004",
      "EGCGBBBQN001",
      "EGCGBPOL001",
      "EGCGBFM001",
      "EGCGBETSR006",
      "EGCGBETSR002",
      "EGCGBETSR004",
      "EGCGBETSR005",
      "EGCGBZOMA001",
      "EGCGBTC001",
      "EGCGBMURO002"
    ],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Kids",
    "sku": ["EGCGBRBLH001"],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Electronics",
    "sku": [
      "EGCGBCROM001",
      "EGCGBGUP001",
      "EGCGBREL001",
      "EGCGBREL004",
      "EGCGBGIRI001",
      "EGCGBVIJSAL001"
    ],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Crowdfunding Platform",
    "sku": ["EGCGBDKART001"],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Jewellery",
    "sku": [
      "EGCGBORZ001",
      "EGCGBGJ002",
      "EGCGBKJ014",
      "EGCGBGVSC001",
      "EGCGBAHJ001",
      "EGCGBPCJ004",
      "EGCGBJOY003",
      "EGCGBJAJ004",
      "EGCGBTANISHQMIA002",
      "EGCGBKJ015",
      "EGCGBREL003",
      "EGCGBTSQ002",
      "EGCGBJOY001",
      "EGCGBBS003",
      "EGCGBBS001",
      "EGCGBBS004",
      "EGVGBBHJ001",
      "EGCGBTSQ003",
      "EGCGBGRTJ001",
      "EGCGBKJ016",
      "EGCGBJOY002",
      "EGCGBPCJ005",
      "EGCGBTBZ001",
      "EGCGBJS002",
      "EGCGBBS002",
      "EGVGBBHJ002",
      "EGCGBPCCGC001",
      "EGCGBPCJ006",
      "EGCGBTSQ004",
      "EGCGBGJ001"
    ],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Groceries",
    "sku": [
      "EGCGBRDSM001",
      "EGCGBRELSB001",
      "EGCGBRELSS001",
      "EGCGBRELSP001",
      "EGCGBBBS001",
      "EGCGBRRLTD008",
      "EGCGBGNB001",
      "EGCGBSR002",
      "EGCGBZPT001"
    ],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Footwear",
    "sku": ["EGCGBBIRSTK001", "EGCGBSKC001"],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Home Furnishing",
    "sku": ["EGCGBUL002", "EGCGBPPFCORPS001", "EGCGBWF001"],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Health & Beauty",
    "sku": [
      "EGCGBLKME001",
      "EGCGBCFIT002",
      "GVGBHIS001",
      "EGCGBHNG001",
      "EGCGBBCR001",
      "EGCGBO2SS001"
    ],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Home Appliance",
    "sku": ["EGCGBTTKS001"],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Hotels",
    "sku": [
      "EGCGBMTHI002",
      "EGCGBPCHR001",
      "EGCGBTLEL005",
      "EGCGBITCL005",
      "EGCGBOHR001",
      "GBV2TAJCORPEGC001",

    ],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Hypermarket",
    "sku": ["EGCGBLUH001"],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Movie",
    "sku": ["EGVGBPVRC001"],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Travel",
    "sku": [
      "EGCGBEMT001",
      "EGCGBSH001",
      "EGCGBMMTHOTC001",
      "EGCGBMMTHOLC001",
      "EGCGBYRA002",
      "EGCGBYATRA001",
      "EGCGBSTOC001",
      "EGCGBMMTCR001",
      "EGCGBMMTGEN001",
      "EGCGBMMTWD001",
      "EGCGBAIQC001",
      "EGCGBUBER001",
      "EGCGBMMTBUSGB001",
      "EGCGBMMTRAILGB002",
      "EGCGBHIT004",
      "EGCGBHIT003",
      "EGCGBHIT001",
      "EGCGBHIT002"
    ],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Watches",
    "sku": [
      "EGVGBWOTB2C002",
      "EGVGBFTB2C002",
      "EGVGBFTS001",
      "EGVGBTNS001",
      "EGVGBHLS001"
    ],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Sports",
    "sku": ["EGCGBDCN003"],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Subscription",
    "sku": [
      "EGCGBEPON004",
      "EGCGBEPON003",
      "EGCGBEPON001",
      "EGCGBEPON002",
      "EGCGBFC001"
    ],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Online Shopping",
    "sku": ["EGVFK002","EGCGBTCQ002","EGCGBTCQP015","EGCGBZPT001","EGCGBZOMA001","EGCGBAJIORRL001","EGCGBETSR005","EGCGBETSR002","EGCGBETSR004","EGCGBMEA001","EGCGBMYG001","EGCGBMYTS009","EGCGBNYKA003","EGCGBNYKA006","EGCGBNYKA007","EGCGBETSR006"],
    "suggestedFor": "Group & Solo Gifting"
  },
  {
    "category": "Charity",
    "sku": ["EGCGBSTCAR021"],
    "suggestedFor": "Solo Gifting Only"
  },
  {
    "category": "Fashion",
    "sku": ["EGCGBRBL001", "EGCGBWRNGLR001", "EGCGBAD001", "EGCGBLEE001", "EGCGBSC001", "EGCGBAE001", "EGCGBWLCR001"],
    "suggestedFor": "Solo Gifting Only"
  },
  {
    "category": "Home Appliance",
    "sku": ["EGCGBWDCF001"],
    "suggestedFor": "Solo Gifting Only"
  },
  {
    "category": "Food & Beverages",
    "sku": ["EGCGBMCDM003", "EGCGBPZH001", "EGCGBTBS001"],
    "suggestedFor": "Solo Gifting Only"
  },
  {
    "category": "Home Furnishing",
    "sku": ["EGCGBNIL001"],
    "suggestedFor": "Solo Gifting Only"
  },
  {
    "category": "Groceries",
    "sku": ["EGCGBMOR001"],
    "suggestedFor": "Solo Gifting Only"
  },
  {
    "category": "Health & Beauty",
    "sku": ["EGCGBTBSQ001", "EGCGBKQR001"],
    "suggestedFor": "Solo Gifting Only"
  },
  {
    "category": "Hotels",
    "sku": [ "EGCGBMARI006", "EGCGBMARI002", "EGCGBMARI004"],
    "suggestedFor": "Solo Gifting Only"
  },
  {
    "category": "Jewellery",
    "sku": ["EGCGBGM001", "EGCGBSUDI001", "EGCGBSUDI002", "EGCGBSUDI003"],
    "suggestedFor": "Solo Gifting Only"
  },
  {
    "category": "Kids",
    "sku": ["EGCGBMK002", "EGCGBHML002"],
    "suggestedFor": "Solo Gifting Only"
  },
  {
    "category": "Electronics",
    "sku": ["EGCGBRESONATE001"],
    "suggestedFor": "Solo Gifting Only"
  },
  {
    "category": "Travel",
    "sku": ["EGCGBCTH006", "EGCGBCTH005"],
    "suggestedFor": "Solo Gifting Only"
  }
];